import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { authActions } from '@store/auth/auth.slice';

import { RouteEnum } from '@enum/route.enum';
import { useCallbackMutation } from '@hook/auth/auth.hooks';
import { useMutation } from '@hook/common/use-mutation.hook';
import { useLocalStorage } from '@hook/store/use-local-storage.hook';

export const useLoginCallback = () => {
  const { action: login } = useMutation(useCallbackMutation(), authActions, authActions.setData);
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const [isVelory, setVelory] = useLocalStorage<boolean>('YynaGVxYpg8G');

  useEffect(() => {
    const code = params.get('code');
    if (code) {
      login({ code, isVelory }).catch(() => navigate(RouteEnum.Login.path));
      setVelory(undefined);
    } else {
      setVelory(undefined);
      navigate(RouteEnum.Login.path);
    }
  }, [params]);
};
